import { render, staticRenderFns } from "./CustomerAdd.vue?vue&type=template&id=deb93912&"
import script from "./CustomerAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports